import React, { useState } from 'react';
import './Photos.css';

// 각 폴더의 이미지를 동적으로 불러오기
const cauRecitalImages = require.context('../posts/photos/cau-recital-2023/images', false, /\.(png|jpe?g|svg)$/);
const cauRecitalList = cauRecitalImages.keys().map(image => cauRecitalImages(image));

const citiphilharmoniImages = require.context('../posts/photos/citiphilharmoni-2021/images', false, /\.(png|jpe?g|svg)$/);
const citiphilharmoniList = citiphilharmoniImages.keys().map(image => citiphilharmoniImages(image));

const italyImages = require.context('../posts/photos/Italy-2022/images', false, /\.(png|jpe?g|svg)$/);
const italyList = italyImages.keys().map(image => italyImages(image));

const seoulChoralImages = require.context('../posts/photos/Seoul-Choral-Festival-2023/images', false, /\.(png|jpe?g|svg)$/);
const seoulChoralList = seoulChoralImages.keys().map(image => seoulChoralImages(image));

function Photos() {
  const [selectedAlbum, setSelectedAlbum] = useState(null);

  const albums = [
    {
      id: 'cau-recital',
      title: 'Chung-Ang University Recital',
      date: 'February 2023',
      thumbnail: cauRecitalList[0], 
      description: 'Recital at Chung-Ang University',
      photos: cauRecitalList.map((image, index) => ({
        id: index + 1,
        src: image,
        alt: `CAU Recital Photo ${index + 1}`
      }))
    },
    {
      id: 'citiphilharmoni',
      title: 'CitiPhilharmoni Orchestra',
      date: '2021',
      thumbnail: citiphilharmoniList[0],
      description: 'CitiPhilharmoni Orchestra performance',
      photos: citiphilharmoniList.map((image, index) => ({
        id: index + 1,
        src: image,
        alt: `CitiPhilharmoni Photo ${index + 1}`
      }))
    },
    {
      id: 'italy',
      title: 'Civica Scuola Delle Arti (Italy)',
      date: '2022',
      thumbnail: italyList[0],
      description: 'Performance in Italy',
      photos: italyList.map((image, index) => ({
        id: index + 1,
        src: image,
        alt: `Italy Photo ${index + 1}`
      }))
    },
    {
      id: 'seoul-choral-festival',
      title: 'Seoul Choral Festival',
      date: '2023',
      thumbnail: seoulChoralList[0],
      description: 'Seoul Choral Festival performance',
      photos: seoulChoralList.map((image, index) => ({
        id: index + 1,
        src: image,
        alt: `Seoul Choral Festival Photo ${index + 1}`
      }))
    }
  ];

  const handleAlbumClick = (albumId) => {
    setSelectedAlbum(albumId === selectedAlbum ? null : albumId);
  };

  return (
    <div className="photos-container">
      <h1>Photos</h1>
      <div className="albums-grid">
        {albums.map(album => (
          <div key={album.id} className="album-card" onClick={() => handleAlbumClick(album.id)}>
            <div className="album-thumbnail">
              <img src={album.thumbnail} alt={album.title} />
            </div>
            <div className="album-info">
              <h2>{album.title}</h2>
              <p className="album-date">{album.date}</p>
            </div>
          </div>
        ))}
      </div>

      {selectedAlbum && (
        <div className="album-view">
          <div className="album-header">
            <h2>{albums.find(a => a.id === selectedAlbum).title}</h2>
            <button className="close-button" onClick={() => setSelectedAlbum(null)}>×</button>
          </div>
          <div className="photos-grid">
            {albums
              .find(a => a.id === selectedAlbum)
              .photos.map(photo => (
                <div key={photo.id} className="photo-item">
                  <img src={photo.src} alt={photo.alt} />
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Photos;
